import { useCallback } from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, ComponentLoader } from 'components';
import CollapsibleTable from 'components/atoms/GefMui/CollapsibleTable';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import { loadMore, loadPage, searchSemaphoreList } from 'features/views/semaphore/actions';
import { REQUEST_SIZE_LIMIT } from 'features/views/semaphore/constants';
import { getSemaphoreRecords } from 'features/views/semaphore/selectors';

import SemaphoreFeedbackDetailModal from '../modals/SemaphoreFeedbackDetailModal';
import SemaphoreTableRow from './SemaphoreTableRow';

export const ResultsTable = () => {
	const dispatch = useDispatch();
	const semaphoreRecords = useSelector(getSemaphoreRecords);
	const fetchState = useSelector(fetch.selectors.getFetchState(fetch.constants.urls.semaphoreList));

	const handleReload = useCallback(() => {
		dispatch(searchSemaphoreList());
	}, [dispatch]);

	const handleLoadMore = useCallback(() => {
		dispatch(loadMore());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(loadPage(page - 1));
		},
		[dispatch],
	);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.semaphoreSaveFeedbackValue} ignoreErrors>
			<ComponentLoader fetchStorePath={fetch.constants.urls.semaphoreList} onReload={handleReload}>
				<SemaphoreFeedbackDetailModal id={MODALS.semaphore_feedback_detail} />
				<CollapsibleTable
					tableId="SemaphoreResultsTable"
					autoCloseOtherRows
					tableHeader={
						<TableHead>
							<TableRow>
								<TableCell />
								<TableCell>{getLabelMessage('semaphore:policyHolder')}</TableCell>
								<TableCell>
									{<div>{getLabelMessage('semaphore:personIn')}</div>}
									{<div>{getLabelMessage('semaphore:businessIn')}</div>}
								</TableCell>
								<TableCell>{getLabelMessage('semaphore:zipCode')}</TableCell>
								<TableCell>{getLabelMessage('semaphore:municipality')}</TableCell>
								<TableCell>{getLabelMessage('semaphore:feedback')}</TableCell>
								<TableCell />
								<TableCell />
								<TableCell />
							</TableRow>
						</TableHead>
					}
					tableBody={
						isEmpty(semaphoreRecords) ? (
							<TableHasNoResults fetchState={fetchState} />
						) : (
							semaphoreRecords.map((record, id) => <SemaphoreTableRow record={record} id={id} />)
						)
					}
				>
					{
						<PaginationRow
							fetchStorePath={fetch.constants.urls.semaphoreList}
							onLoadNext={handleLoadMore}
							onPaginationClick={handlePaginationClick}
							customResultsLimit={REQUEST_SIZE_LIMIT}
							hideOnResultsLimit
						/>
					}
				</CollapsibleTable>
			</ComponentLoader>
		</ComponentLoader>
	);
};

export default codelistProvider(codelists.semaphoreContactTypes, 'semaphoreContactTypes')(ResultsTable);
